import { render, staticRenderFns } from "./DesktopInside.vue?vue&type=template&id=56fef5ed&scoped=true&"
import script from "./DesktopInside.vue?vue&type=script&lang=js&"
export * from "./DesktopInside.vue?vue&type=script&lang=js&"
import style0 from "./DesktopInside.vue?vue&type=style&index=0&id=56fef5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fef5ed",
  null
  
)

export default component.exports